/**
 * /app/$tenantSlug/hiring/referrals — HR referral inbox (Wave K1.4).
 *
 * HR-admin only (hard HrAdminGate; backend RequireRole re-checks).
 * Convert / reject employee referrals, download résumés, link to the
 * created candidate, and pay hired-referral bonuses into the open
 * payroll run.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HrAdminGate } from "@/components/hiring/hr-admin-gate";
import { ReferralInbox } from "@/components/hiring/referral-inbox";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/referrals",
)({
  component: HiringReferralsRoute,
});

function HiringReferralsRoute() {
  return (
    <HiringModuleShell
      title="Referrals"
      description="Employee-submitted referrals — convert to candidates, reject, and pay hire bonuses."
    >
      <HrAdminGate
        title="Referrals"
        description="Employee referral inbox."
      >
        <ReferralInbox />
      </HrAdminGate>
    </HiringModuleShell>
  );
}
